"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWhenAloneInRoom = exports.useFilteredRoles = exports.useBeamAutoLeave = void 0;
var _reactSdk = require("@100mslive/react-sdk");
var _react = require("react");
var _useUISettings = require("../components/AppData/useUISettings");
var _utils = require("./utils");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * Hook to execute a callback when alone in room(after a certain 5d of time)
 * @param {number} thresholdMs The threshold(in ms) after which the callback is executed,
 * starting from the instant when alone in room.
 * note: the cb is not called when another peer joins during this period.
 */
var useWhenAloneInRoom = function useWhenAloneInRoom() {
  var thresholdMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5 * 60 * 1000;
  var isConnected = (0, _reactSdk.useHMSStore)(_reactSdk.selectIsConnectedToRoom);
  var peerCount = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeerCount);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    aloneForLong = _useState2[0],
    setAloneForLong = _useState2[1];
  var cbTimeout = (0, _react.useRef)(null);
  var alone = isConnected && peerCount === 1;
  (0, _react.useEffect)(function () {
    if (alone && !cbTimeout.current) {
      // @ts-ignore
      cbTimeout.current = setTimeout(function () {
        setAloneForLong(true);
      }, thresholdMs);
    } else if (!alone) {
      cbTimeout.current && clearTimeout(cbTimeout.current);
      cbTimeout.current = null;
      setAloneForLong(false);
    }
  }, [alone, thresholdMs]);
  (0, _react.useEffect)(function () {
    return function () {
      if (cbTimeout.current) {
        clearTimeout(cbTimeout.current);
      }
    };
  }, []);
  return {
    alone: alone,
    aloneForLong: aloneForLong
  };
};
exports.useWhenAloneInRoom = useWhenAloneInRoom;
var useBeamAutoLeave = function useBeamAutoLeave() {
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var permissions = (0, _reactSdk.useHMSStore)(_reactSdk.selectPermissions);
  var isHeadless = (0, _useUISettings.useIsHeadless)();
  var _useWhenAloneInRoom = useWhenAloneInRoom(),
    aloneForLong = _useWhenAloneInRoom.aloneForLong;
  var _useRecordingStreamin = (0, _reactSdk.useRecordingStreaming)(),
    isHLSRunning = _useRecordingStreamin.isHLSRunning,
    isRTMPRunning = _useRecordingStreamin.isRTMPRunning,
    isBrowserRecordingOn = _useRecordingStreamin.isBrowserRecordingOn;

  /**
   * End room after 5 minutes of being alone in the room to stop beam
   * Note: Leave doesn't stop beam
   */
  (0, _react.useEffect)(function () {
    if (aloneForLong && isHeadless) {
      if (permissions !== null && permissions !== void 0 && permissions.endRoom) {
        hmsActions.endRoom(false, "Stop Beam");
      } else {
        if (isHLSRunning && permissions !== null && permissions !== void 0 && permissions.hlsStreaming) {
          hmsActions.stopHLSStreaming();
        }
        if (isRTMPRunning && permissions !== null && permissions !== void 0 && permissions.rtmpStreaming || isBrowserRecordingOn && permissions !== null && permissions !== void 0 && permissions.browserRecording) {
          hmsActions.stopRTMPAndRecording();
        }
      }
    }
  }, [aloneForLong, isHeadless, hmsActions, permissions, isHLSRunning, isRTMPRunning, isBrowserRecordingOn]);
};
exports.useBeamAutoLeave = useBeamAutoLeave;
var useFilteredRoles = function useFilteredRoles() {
  var roles = (0, _reactSdk.useHMSStore)(_reactSdk.selectAvailableRoleNames).filter(function (role) {
    return !(0, _utils.isInternalRole)(role);
  });
  return roles;
};
exports.useFilteredRoles = useFilteredRoles;